import React, { useState } from "react";
import { connect } from "react-redux";
import { object, func, bool, string } from "prop-types";

import {
  onboardUpdateState,
  updateUserInProfileSilent,
} from "../../redux/actions";
import {
  getUTCDate,
  getFieldValue,
  getAvailability,
  getWorkHours,
  getWorkTypes,
  arrayXor,
} from "../../helpers";

import WorkTypeView from "../../components/WorkType";

import history from "../../history";
import { toInt } from "../../helpers/helpers";
import { trackOnboardingStep } from "../../helpers/productMetrics";

const onboardNextRoute = "/onboard/personal-declaration";
const editProfileNextRoute = "/profile";

const toggle = (currentItems, newSelections) =>
  arrayXor(currentItems, newSelections);

const useWorkTypeState = (appData) => {
  const initialState = {
    selectedTypes: getWorkTypes(appData),
    selectedHours: getWorkHours(appData),
    minSalary: getFieldValue(appData, "minimumSalary"),
    salaryFrequency: getFieldValue(appData, "rateMode", "H"),
    positionSeeking: getFieldValue(appData, "positionSeeking"),
    availabilityDay: appData.availability
      ? getAvailability(appData.availability)[0]
      : "",
    availabilityMonth: appData.availability
      ? getAvailability(appData.availability)[1]
      : "",
    availabilityYear: appData.availability
      ? getAvailability(appData.availability)[2]
      : "",
    lookingForDrivingJob: appData.lookingForDrivingJob,
    ownCar: appData.ownCar,
    driver: appData.driver,
  };
  const [state, setState] = useState(initialState);

  const handlers = {
    toggleType: (value) =>
      setState({
        ...state,
        selectedTypes: toggle(state.selectedTypes, [value]),
      }),
    toggleBothTypes: () =>
      setState({
        ...state,
        selectedTypes:
          state.selectedTypes.length < 2 ? ["permanent", "temp"] : [],
      }),
    toggleHours: (value) =>
      setState({
        ...state,
        selectedHours: toggle(state.selectedHours, [value]),
      }),
    toggleBothHours: () =>
      setState({
        ...state,
        selectedHours: state.selectedHours.length < 2 ? ["full", "part"] : [],
      }),
    onChange: (key, val) => setState({ ...state, [key]: val }),
  };
  return [state, handlers];
};

const WorkType = (props) => {
  const {
    appData,
    onboardState,
    description,
    seekingDescription,
    updateProfile,
    updateOnboardState,
    onBoarding = true,
  } = props;

  const [state, handlers] = useWorkTypeState(appData);

  const {
    selectedHours,
    minSalary,
    salaryFrequency,
    positionSeeking,
    availabilityDay,
    availabilityMonth,
    availabilityYear,
    ownCar,
    driver,
  } = state;

  const handleSubmit = () => {
    const { candidateRef, emailAddress } = appData;
    const availabilityDate = new Date(
      toInt(availabilityYear),
      toInt(availabilityMonth),
      toInt(availabilityDay)
    );
    const dateAvailability = getUTCDate(availabilityDate);
    const updatedUserData = {
      candidateRef,
      emailAddress,
      positionSeeking,
      tempWorkSeeking: true,
      permWorkSeeking: false,
      fullTimeHours: selectedHours.includes("full"),
      partTimeHours: selectedHours.includes("part"),
      minimumSalary: minSalary,
      rateMode: salaryFrequency,
      availability: dateAvailability,
      ownCar,
      driver,
    };
    Promise.all([
      updateProfile(candidateRef, updatedUserData),
      updateOnboardState({ ...onboardState, workType: true }),
      onBoarding && trackOnboardingStep("Work Type"),
    ]).then(() =>
      history.push(onBoarding ? onboardNextRoute : editProfileNextRoute)
    );
  };

  return (
    <WorkTypeView
      {...props}
      {...state}
      {...handlers}
      description={description}
      seekingDescription={seekingDescription}
      handleSubmit={handleSubmit}
      onBoarding={onBoarding}
      onboardNextRoute={onboardNextRoute}
    />
  );
};

WorkType.propTypes = {
  appData: object.isRequired,
  updateProfile: func.isRequired,
  updateOnboardState: func.isRequired,
  onboardState: object.isRequired,
  onBoarding: bool,
  description: string.isRequired,
  seekingDescription: string.isRequired,
  loading: bool.isRequired,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
  onboardState: state.core.onboardState,
  description: state.core.umbracoContent.workTypeSub,
  seekingDescription: state.core.umbracoContent.desiredPositionSub,
});
const mapDispatchToProps = {
  updateOnboardState: onboardUpdateState,
  updateProfile: updateUserInProfileSilent,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(WorkType);
